import { FormArray, ValidatorFn } from '@angular/forms';
import { EmailControl } from './email-control';

export class EscalationMailFormArray extends FormArray {
    public value: string[];
    public get emailFormControls(): EmailControl[] {
      return this.controls as EmailControl[];
    }
    constructor() {
      super([], [EscalationMailFormArray.baseMailsValidator()]);
    }
  
    public getByIndex(emailIndex: number): EmailControl {
      return this.at(emailIndex) as EmailControl;
    }
  
    private static baseMailsValidator(): ValidatorFn {
      return (mailControls: EscalationMailFormArray) => {
        for (let mailControl of mailControls.emailFormControls) {
          mailControl.updateValueAndValidity({ onlySelf: true });
        }
        return null;
      };
    }
  }

export class EscalationMailDrop {
  public dropFrom: string;
  public dropTo: string;
  public mail: string;
}